import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, CalendarHolidays, Planzone } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  defaultCalendarHolidays: Identifiable<CalendarHolidays>;
  retrieveDefaultCalendarHolidays(
    credentials: Boundaries["retrieveDefaultCalendarHolidays"]["request"],
  ): void;
}

function useRetrieveDefaultCalendarHolidays(
  planzone: Identifiable<Planzone>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveDefaultCalendarHolidaysRequestPending(planzone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveDefaultCalendarHolidaysRequestSuccess(planzone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveDefaultCalendarHolidaysRequestFailure(planzone),
    ),
    defaultCalendarHolidays: useSelector(() =>
      selector.getDefaultCalendarHolidays(planzone),
    ),
    retrieveDefaultCalendarHolidays: core.retrieveDefaultCalendarHolidays,
  };
}

export { useRetrieveDefaultCalendarHolidays };
